<template>
  <div class="page">
    <h2 class="page-title">理疗客户管理</h2>
    <div class="toolbar card">
      <input v-model.trim="filters.name" class="control" placeholder="姓名" />
      <input v-model.trim="filters.phone" class="control" placeholder="手机号(11位)" maxlength="11" />
      <select v-model="filters.customerTypeId" class="control control-select">
        <option value="">全部类型</option>
        <option v-for="t in customerTypes" :key="t.id" :value="t.id">{{ t.name }}</option>
      </select>
      <select v-model="filters.linked" class="control control-select">
        <option value="">关联状态</option>
        <option value="true">已关联微信</option>
        <option value="false">未关联</option>
      </select>
      <button type="button" class="btn btn-primary" :disabled="loading" @click="search">查询</button>
      <button type="button" class="btn btn-primary" :disabled="loading" @click="openCreate">新增客户</button>
      <button type="button" class="btn btn-ghost" :disabled="loading" @click="openImportDialog">批量导入</button>
      <button type="button" class="btn btn-ghost" :disabled="loading" @click="loadList">刷新</button>
    </div>
    <div class="table-wrap card">
    <table class="data-table">
      <thead>
        <tr>
          <th>姓名</th>
          <th>手机号</th>
          <th>性别</th>
          <th>客户类型</th>
          <th>预约数</th>
          <th>最近预约</th>
          <th>微信</th>
          <th>创建时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.phoneMasked }}</td>
          <td>{{ genderLabel(item.gender) }}</td>
          <td>{{ item.customerType?.name || '—' }}</td>
          <td>{{ item.bookingCount ?? 0 }}</td>
          <td>{{ formatDt(item.lastBookingAt) }}</td>
          <td>{{ item.wechatLinked ? '已关联' : '未关联' }}</td>
          <td>{{ formatDt(item.createdAt) }}</td>
          <td class="cell-actions">
            <button type="button" class="btn btn-sm btn-ghost" :disabled="loading" @click="openDetail(item)">详情</button>
            <button type="button" class="btn btn-sm btn-primary" :disabled="loading" @click="openEdit(item)">编辑</button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    <div class="pagination card-flat" v-if="totalPages > 1">
      <button type="button" class="btn btn-ghost" :disabled="loading || page <= 0" @click="goPage(page - 1)">上一页</button>
      <span class="page-info">{{ page + 1 }} / {{ totalPages }}（共 {{ totalElements }} 条）</span>
      <button type="button" class="btn btn-ghost" :disabled="loading || page >= totalPages - 1" @click="goPage(page + 1)">下一页</button>
    </div>

    <div v-if="showForm" class="dialog-mask">
      <div class="dialog dialog-form">
        <div class="dialog-header">
          <h3>{{ editingId ? '编辑理疗客户' : '新增理疗客户' }}</h3>
        </div>
        <div class="form-stack">
          <div class="form-field">
            <label>手机号{{ editingId ? '（不可改）' : '' }}</label>
            <input v-model="form.phone" class="control" :disabled="!!editingId" placeholder="11位手机号" maxlength="11" />
          </div>
          <div class="form-field">
            <label>姓名</label>
            <input v-model="form.name" class="control" placeholder="姓名" />
          </div>
          <div class="form-field">
            <label>性别</label>
            <select v-model="form.gender" class="control control-select">
              <option value="">未填</option>
              <option value="MALE">男</option>
              <option value="FEMALE">女</option>
              <option value="UNKNOWN">未知</option>
            </select>
          </div>
          <div class="form-field">
            <label>出生日期</label>
            <input v-model="form.birthDate" class="control" placeholder="如 1990-01-01" />
          </div>
          <div class="form-field">
            <label>地址</label>
            <input v-model="form.address" class="control" placeholder="地址" />
          </div>
          <div class="form-field">
            <label>客户类型</label>
            <select v-model.number="form.customerTypeId" class="control control-select">
              <option :value="null">未设置</option>
              <option v-for="t in customerTypes" :key="'f-' + t.id" :value="t.id">{{ t.name }}</option>
            </select>
          </div>
          <div class="form-field">
            <label>备注</label>
            <textarea v-model="form.notes" class="control control-textarea" placeholder="管理员备注" rows="3"></textarea>
          </div>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-ghost" :disabled="loading" @click="showForm = false">取消</button>
          <button type="button" class="btn btn-primary" :disabled="loading" @click="save">保存</button>
        </div>
      </div>
    </div>

    <div v-if="showDetail" class="dialog-mask">
      <div class="dialog dialog-wide">
        <div class="dialog-header">
          <h3>客户详情 — {{ detail.name }}</h3>
        </div>
        <p class="meta meta-row">
          <span>手机 {{ detail.phoneMasked }} · 类型 {{ detail.customerType?.name || '—' }}</span>
          <span class="meta-wechat-inline">
            <span>{{ detail.wechatLinked ? '已关联微信' : '未关联微信' }}</span>
            <button
              v-if="detail.wechatLinked"
              type="button"
              class="btn btn-sm btn-ghost btn-unlink-wx"
              :disabled="loading"
              title="解除后可用正确微信登录，系统将按手机号自动重新关联档案"
              @click="confirmUnlinkWechat"
            >取消关联</button>
          </span>
        </p>
        <div class="tabs">
          <button type="button" class="tab-btn" :class="{ active: detailTab === 'bookings' }" @click="switchTab('bookings')">预约记录</button>
          <button type="button" class="tab-btn" :class="{ active: detailTab === 'reviews' }" @click="switchTab('reviews')">评价记录</button>
          <button type="button" class="btn btn-sm btn-ghost tab-inline" @click="openTypeDialog">修改类型</button>
        </div>
        <div v-if="detailTab === 'bookings'" class="tab-panel">
          <table class="data-table data-table-compact">
            <thead>
              <tr><th>预约号</th><th>活动</th><th>理疗师</th><th>时间</th><th>状态</th><th>实付</th></tr>
            </thead>
            <tbody>
              <tr v-for="b in bookings" :key="b.id">
                <td>{{ b.bookingNo }}</td>
                <td>{{ b.therapy?.name }}</td>
                <td>{{ b.therapist?.name || '—' }}</td>
                <td>{{ b.bookingDate }} {{ b.startTime }}</td>
                <td>{{ statusMap[b.status] || b.status }}</td>
                <td>{{ b.actualAmount }}</td>
              </tr>
            </tbody>
          </table>
          <p v-if="!bookings.length && !detailLoading">暂无预约（未关联微信或无订单）</p>
        </div>
        <div v-if="detailTab === 'reviews'" class="tab-panel">
          <table class="data-table data-table-compact">
            <thead>
              <tr><th>活动</th><th>评分</th><th>内容</th><th>时间</th></tr>
            </thead>
            <tbody>
              <tr v-for="r in reviews" :key="r.id">
                <td>{{ r.therapy?.name }}</td>
                <td>{{ r.rating }}</td>
                <td>{{ r.content }}</td>
                <td>{{ formatDt(r.createdAt) }}</td>
              </tr>
            </tbody>
          </table>
          <p v-if="!reviews.length && !detailLoading">暂无评价</p>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-primary" :disabled="loading" @click="showDetail = false">关闭</button>
        </div>
      </div>
    </div>

    <div v-if="showTypeDialog" class="dialog-mask">
      <div class="dialog dialog-form">
        <div class="dialog-header">
          <h3>修改客户类型</h3>
        </div>
        <div class="form-field form-field-tight">
          <label>客户类型</label>
          <select v-model.number="typeForm.customerTypeId" class="control control-select">
            <option :value="null">清空类型</option>
            <option v-for="t in customerTypes" :key="'t-' + t.id" :value="t.id">{{ t.name }}</option>
          </select>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-ghost" :disabled="loading" @click="showTypeDialog = false">取消</button>
          <button type="button" class="btn btn-primary" :disabled="loading" @click="saveType">确定</button>
        </div>
      </div>
    </div>

    <div v-if="showImportDialog" class="dialog-mask">
      <div class="dialog dialog-wide dialog-import">
        <div class="dialog-header">
          <h3>批量导入理疗客户</h3>
        </div>
        <div class="import-body">
          <p class="import-hint">从 Excel 批量导入客户并设定客户类型（折扣）。手机号已存在时将更新其客户类型。</p>
          <div class="import-columns">
            <h4>列说明</h4>
            <ul>
              <li><strong>姓名</strong>、<strong>手机号</strong>（11 位）、<strong>客户类型</strong>（必填，须与下方列表名称完全一致）</li>
              <li><strong>备注</strong>（选填，仅新建档案时写入）</li>
              <li>下载的模板含「客户类型参考」工作表，列出当前系统全部可用类型</li>
            </ul>
          </div>
          <div v-if="activeCustomerTypes.length" class="import-types-panel">
            <h4>可用客户类型（共 {{ activeCustomerTypes.length }} 种）</h4>
            <div class="import-types-scroll">
              <table class="data-table data-table-compact">
                <thead>
                  <tr><th>类型名称</th><th>折扣率</th><th>说明</th></tr>
                </thead>
                <tbody>
                  <tr v-for="t in activeCustomerTypes" :key="'import-t-' + t.id">
                    <td>{{ t.name }}</td>
                    <td>{{ t.discountRate }}%</td>
                    <td>{{ t.description || '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p v-else class="import-hint import-hint-warn">暂无可用客户类型，请先在「客户类型管理」中创建并启用。</p>
          <div class="import-actions">
            <button type="button" class="btn btn-ghost" :disabled="importBusy" @click="downloadImportTemplate">下载模板</button>
            <label class="import-file-picker">
              <input
                ref="importFileInput"
                type="file"
                accept=".xlsx,.xls"
                :disabled="importBusy"
                @change="onImportFileChange"
              />
              <span>{{ importFile ? importFile.name : '选择 Excel…' }}</span>
            </label>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!importFile || importBusy"
              @click="submitImport"
            >
              {{ importBusy ? '导入中…' : '开始导入' }}
            </button>
          </div>
          <p v-if="importMessage" :class="['import-message', importMessageKind]">{{ importMessage }}</p>
          <section v-if="importReport" class="import-report">
            <h4>导入结果</h4>
            <div class="import-summary">
              <div><span class="label">数据行数</span><span class="value">{{ importReport.totalRows }}</span></div>
              <div><span class="label">新建</span><span class="value">{{ importReport.created }}</span></div>
              <div><span class="label">更新</span><span class="value">{{ importReport.updated }}</span></div>
            </div>
            <div v-if="importReport.errors && importReport.errors.length" class="import-subsection">
              <h5>错误</h5>
              <div class="table-wrap">
                <table class="data-table data-table-compact">
                  <thead>
                    <tr><th>行号</th><th>姓名</th><th>说明</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in importReport.errors" :key="'ie-' + idx">
                      <td>{{ item.row }}</td>
                      <td>{{ item.name || '—' }}</td>
                      <td>{{ item.message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="importReport.warnings && importReport.warnings.length" class="import-subsection">
              <h5>警告 / 提示</h5>
              <div class="table-wrap">
                <table class="data-table data-table-compact">
                  <thead>
                    <tr><th>行号</th><th>姓名</th><th>说明</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in importReport.warnings" :key="'iw-' + idx">
                      <td>{{ item.row }}</td>
                      <td>{{ item.name || '—' }}</td>
                      <td>{{ item.message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-primary" :disabled="importBusy" @click="closeImportDialog">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { therapyCustomerService } from '@/services/therapyCustomerService'
import { customerTypeService } from '@/services/customerTypeService'

export default {
  name: 'TherapyCustomerManagement',
  data() {
    return {
      list: [],
      page: 0,
      size: 10,
      totalElements: 0,
      totalPages: 1,
      filters: { name: '', phone: '', customerTypeId: '', linked: '' },
      customerTypes: [],
      loading: false,
      showForm: false,
      editingId: null,
      form: this.emptyForm(),
      showDetail: false,
      detail: {},
      detailTab: 'bookings',
      bookings: [],
      reviews: [],
      detailLoading: false,
      showTypeDialog: false,
      typeForm: { customerTypeId: null },
      showImportDialog: false,
      importBusy: false,
      importFile: null,
      importReport: null,
      importMessage: '',
      importMessageKind: '',
      statusMap: {
        PENDING_PAYMENT: '待付款',
        PAID: '已付款',
        CONFIRMED: '已预约',
        CHECKED_IN: '已签到',
        COMPLETED: '已完成',
        CANCELLED: '已取消'
      }
    }
  },
  mounted() {
    this.loadTypes()
    this.loadList()
  },
  computed: {
    activeCustomerTypes() {
      return (this.customerTypes || [])
        .filter(t => t.status === 'ACTIVE')
        .slice()
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
    }
  },
  methods: {
    emptyForm() {
      return {
        phone: '',
        name: '',
        gender: '',
        birthDate: '',
        address: '',
        customerTypeId: null,
        notes: ''
      }
    },
    genderLabel(g) {
      if (g === 'MALE') return '男'
      if (g === 'FEMALE') return '女'
      if (g === 'UNKNOWN') return '未知'
      return '—'
    },
    formatDt(v) {
      if (!v) return '—'
      return String(v).replace('T', ' ').slice(0, 19)
    },
    async loadTypes() {
      try {
        const res = await customerTypeService.fetchList()
        this.customerTypes = res.data || []
      } catch (e) {
        console.error(e)
      }
    },
    linkedParam() {
      if (this.filters.linked === 'true') return true
      if (this.filters.linked === 'false') return false
      return undefined
    },
    async loadList() {
      this.loading = true
      try {
        const res = await therapyCustomerService.fetchList({
          name: this.filters.name || undefined,
          phone: this.filters.phone || undefined,
          customerTypeId: this.filters.customerTypeId === '' ? undefined : this.filters.customerTypeId,
          linked: this.linkedParam(),
          page: this.page,
          size: this.size
        })
        const pageData = res.data || {}
        this.list = pageData.content || []
        this.totalElements = pageData.totalElements ?? 0
        this.totalPages = pageData.totalPages || 1
      } catch (e) {
        alert(e?.response?.data?.error || e?.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    search() {
      this.page = 0
      this.loadList()
    },
    goPage(p) {
      this.page = p
      this.loadList()
    },
    openCreate() {
      this.editingId = null
      this.form = this.emptyForm()
      this.showForm = true
    },
    openEdit(row) {
      this.editingId = row.id
      this.form = {
        phone: '',
        name: row.name,
        gender: row.gender || '',
        birthDate: row.birthDate || '',
        address: row.address || '',
        customerTypeId: row.customerTypeId ?? null,
        notes: row.notes || ''
      }
      this.showForm = true
    },
    async save() {
      this.loading = true
      try {
        const payload = {
          name: this.form.name,
          gender: this.form.gender || undefined,
          birthDate: this.form.birthDate || undefined,
          address: this.form.address || undefined,
          customerTypeId: this.form.customerTypeId,
          notes: this.form.notes || undefined
        }
        if (!this.editingId) {
          payload.phone = this.form.phone
          await therapyCustomerService.create(payload)
        } else {
          await therapyCustomerService.update(this.editingId, payload)
        }
        this.showForm = false
        await this.loadList()
      } catch (e) {
        alert(e?.response?.data?.error || e?.message || '保存失败')
      } finally {
        this.loading = false
      }
    },
    async openDetail(row) {
      this.detailLoading = true
      this.showDetail = true
      this.detailTab = 'bookings'
      this.bookings = []
      this.reviews = []
      try {
        const res = await therapyCustomerService.get(row.id)
        this.detail = res.data || {}
        await this.loadBookings()
      } catch (e) {
        alert(e?.response?.data?.error || '加载详情失败')
        this.showDetail = false
      } finally {
        this.detailLoading = false
      }
    },
    async switchTab(tab) {
      this.detailTab = tab
      if (tab === 'bookings') await this.loadBookings()
      else await this.loadReviews()
    },
    async loadBookings() {
      if (!this.detail.id) return
      this.detailLoading = true
      try {
        const res = await therapyCustomerService.fetchBookings(this.detail.id, 0, 50)
        this.bookings = res.data?.content || []
      } catch (e) {
        alert(e?.response?.data?.error || '加载预约失败')
      } finally {
        this.detailLoading = false
      }
    },
    async loadReviews() {
      if (!this.detail.id) return
      this.detailLoading = true
      try {
        const res = await therapyCustomerService.fetchReviews(this.detail.id, 0, 50)
        this.reviews = res.data?.content || []
      } catch (e) {
        alert(e?.response?.data?.error || '加载评价失败')
      } finally {
        this.detailLoading = false
      }
    },
    openTypeDialog() {
      this.typeForm.customerTypeId = this.detail.customerTypeId ?? null
      this.showTypeDialog = true
    },
    async saveType() {
      if (!this.detail.id) return
      this.loading = true
      try {
        const res = await therapyCustomerService.patchCustomerType(this.detail.id, this.typeForm.customerTypeId)
        this.detail = res.data || this.detail
        this.showTypeDialog = false
        await this.loadList()
      } catch (e) {
        alert(e?.response?.data?.error || '更新类型失败')
      } finally {
        this.loading = false
      }
    },
    async confirmUnlinkWechat() {
      if (!this.detail.id || !this.detail.wechatLinked) return
      const ok = window.confirm(
        '确定取消该理疗客户与当前微信的关联吗？档案与客户类型仍会保留。\n客户使用正确微信再次打开康养相关页面后，系统将按手机号自动重新关联。\n此前误绑定的微信号上的会员折扣展示将被清除。'
      )
      if (!ok) return
      this.loading = true
      try {
        const res = await therapyCustomerService.unlinkWechat(this.detail.id)
        const d = res.data || {}
        this.detail = { ...this.detail, ...d }
        await this.loadList()
        await this.switchTab(this.detailTab)
      } catch (e) {
        alert(e?.response?.data?.error || e?.message || '取消关联失败')
      } finally {
        this.loading = false
      }
    },
    openImportDialog() {
      this.showImportDialog = true
      this.importFile = null
      this.importReport = null
      this.importMessage = ''
      this.importMessageKind = ''
      this.loadTypes()
    },
    closeImportDialog() {
      this.showImportDialog = false
      this.importFile = null
      this.importReport = null
      this.importMessage = ''
      if (this.$refs.importFileInput) {
        this.$refs.importFileInput.value = ''
      }
    },
    onImportFileChange(event) {
      const f = event.target.files && event.target.files[0]
      this.importFile = f || null
      this.importReport = null
      this.importMessage = ''
    },
    async downloadImportTemplate() {
      this.importMessage = ''
      this.importBusy = true
      try {
        await therapyCustomerService.downloadImportTemplate()
        this.importMessage = '模板已下载'
        this.importMessageKind = 'ok'
      } catch (e) {
        console.error(e)
        this.importMessage = e?.response?.data?.error || e?.message || '下载失败'
        this.importMessageKind = 'err'
      } finally {
        this.importBusy = false
      }
    },
    async submitImport() {
      if (!this.importFile) return
      this.importBusy = true
      this.importMessage = ''
      this.importReport = null
      try {
        const res = await therapyCustomerService.importFromExcel(this.importFile)
        if (res.success) {
          this.importReport = res.data || null
          this.importMessage = res.message || '导入完成'
          this.importMessageKind = 'ok'
          await this.loadList()
        } else {
          this.importMessage = res.error || res.message || '导入失败'
          this.importMessageKind = 'err'
        }
      } catch (e) {
        console.error(e)
        this.importMessage = e?.response?.data?.error || e?.message || '导入失败'
        this.importMessageKind = 'err'
      } finally {
        this.importBusy = false
        if (this.$refs.importFileInput) {
          this.$refs.importFileInput.value = ''
        }
        this.importFile = null
      }
    }
  }
}
</script>

<style scoped>
.page {
  --control-h: 40px;
  --radius: 8px;
  --border: 1px solid #d1d9e0;
  --bg-card: #fff;
  --text: #1f2937;
  --text-muted: #6b7280;
  --primary: #2563eb;
  --primary-hover: #1d4ed8;
  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);
  --shadow-md: 0 10px 40px rgba(15, 23, 42, 0.12);
  padding: 1.25rem 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
  color: var(--text);
}

.page-title {
  margin: 0 0 1rem;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.card {
  background: var(--bg-card);
  border-radius: var(--radius);
  border: var(--border);
  box-shadow: var(--shadow-sm);
}

.card-flat {
  background: transparent;
  border: none;
  box-shadow: none;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-bottom: 1rem;
  align-items: center;
  padding: 0.85rem 1rem;
}

/* 单行控件：输入框与下拉统一高度 */
.control {
  height: var(--control-h);
  min-height: var(--control-h);
  line-height: calc(var(--control-h) - 2px);
  padding: 0 12px;
  box-sizing: border-box;
  width: 100%;
  max-width: 220px;
  font-size: 14px;
  color: var(--text);
  background: #fff;
  border: var(--border);
  border-radius: var(--radius);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.toolbar .control {
  max-width: 180px;
}

.control::placeholder {
  color: #9ca3af;
}

.control:hover:not(:disabled) {
  border-color: #b8c0cc;
}

.control:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.control:disabled {
  background: #f3f4f6;
  color: var(--text-muted);
  cursor: not-allowed;
}

.control-select {
  max-width: 220px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M3 4.5L6 7.5L9 4.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}

.toolbar .control-select {
  max-width: 180px;
}

.dialog-form .control,
.dialog-form .control-select {
  max-width: none;
}

/* 多行备注：与单行控件同宽、同边框体系，高度单独加大 */
.control-textarea {
  height: auto;
  min-height: 88px;
  line-height: 1.5;
  padding: 10px 12px;
  resize: vertical;
  max-width: none;
}

.btn {
  height: var(--control-h);
  min-height: var(--control-h);
  padding: 0 16px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  border-radius: var(--radius);
  border: var(--border);
  cursor: pointer;
  background: #fff;
  color: var(--text);
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
}

.btn-ghost {
  background: #fff;
  border-color: #d1d9e0;
}

.btn-ghost:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #c4cdd6;
}

.btn-sm {
  height: 32px;
  min-height: 32px;
  padding: 0 10px;
  font-size: 13px;
}

.table-wrap {
  overflow: auto;
  padding: 0;
  border-radius: var(--radius);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table thead th {
  text-align: left;
  padding: 12px 14px;
  font-weight: 600;
  font-size: 13px;
  color: var(--text-muted);
  text-transform: none;
  letter-spacing: 0;
  background: #f8fafc;
  border-bottom: var(--border);
  white-space: nowrap;
}

.data-table tbody td {
  padding: 11px 14px;
  border-bottom: 1px solid #eef2f7;
  vertical-align: middle;
}

.data-table tbody tr:hover {
  background: #fafbfc;
}

.data-table-compact thead th,
.data-table-compact tbody td {
  padding: 8px 10px;
  font-size: 13px;
}

.cell-actions {
  white-space: nowrap;
}

.cell-actions .btn + .btn {
  margin-left: 6px;
}

.pagination {
  margin-top: 0.75rem;
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding: 0.5rem 0;
}

.page-info {
  font-size: 14px;
  color: var(--text-muted);
}

.dialog-mask {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.dialog {
  background: var(--bg-card);
  padding: 0;
  border-radius: 12px;
  min-width: 400px;
  max-width: min(440px, 100%);
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-md);
  border: 1px solid #e5e7eb;
}

.dialog-wide {
  min-width: min(720px, 100%);
  max-width: min(920px, 100%);
}

.dialog-form {
  padding-bottom: 1rem;
}

.dialog-header {
  padding: 1.1rem 1.25rem 0.75rem;
  border-bottom: 1px solid #eef2f7;
}

.dialog-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.form-stack {
  padding: 1rem 1.25rem 0;
  overflow-y: auto;
  max-height: calc(90vh - 140px);
}

.form-field {
  margin-bottom: 0.9rem;
}

.form-field-tight {
  padding: 0 1.25rem;
  margin-top: 0.5rem;
}

.form-field label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-muted);
}

.dialog .actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  padding: 1rem 1.25rem 1.1rem;
  border-top: 1px solid #eef2f7;
}

.meta {
  color: var(--text-muted);
  font-size: 14px;
  margin: 0.75rem 1.25rem 0;
  line-height: 1.5;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.75rem;
}

.meta-wechat-inline {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.btn-unlink-wx {
  color: #b45309;
  border-color: #fcd34d;
  background: #fffbeb;
}

.btn-unlink-wx:hover:not(:disabled) {
  background: #fef3c7;
  border-color: #fbbf24;
}

.tabs {
  display: flex;
  gap: 8px;
  margin: 1rem 1.25rem 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}

.tab-btn {
  height: 36px;
  min-height: 36px;
  padding: 0 14px;
  font-size: 14px;
  border: var(--border);
  border-radius: var(--radius);
  background: #fff;
  color: var(--text-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.tab-btn:hover {
  background: #f9fafb;
  color: var(--text);
}

.tab-btn.active {
  background: #eff6ff;
  border-color: #93c5fd;
  color: var(--primary);
  font-weight: 600;
}

.tab-inline {
  margin-left: auto;
}

.tab-panel {
  max-height: 360px;
  overflow: auto;
  margin: 0 1.25rem 0.5rem;
  border: var(--border);
  border-radius: var(--radius);
  background: #fff;
}

.tab-panel .data-table {
  margin: 0;
}

.tab-panel p {
  padding: 1rem;
  margin: 0;
  color: var(--text-muted);
  font-size: 14px;
}

.dialog-wide .actions {
  margin-top: 0.75rem;
}

.dialog-import .import-body {
  padding: 0 1.25rem 0.5rem;
  overflow-y: auto;
  max-height: calc(90vh - 140px);
}

.import-hint {
  margin: 0.75rem 0 0;
  font-size: 14px;
  color: var(--text-muted);
  line-height: 1.5;
}

.import-columns {
  margin-top: 0.85rem;
  font-size: 14px;
}

.import-columns h4,
.import-report h4,
.import-subsection h5 {
  margin: 0 0 0.5rem;
  font-size: 14px;
  font-weight: 600;
}

.import-columns ul {
  margin: 0;
  padding-left: 1.25rem;
  color: var(--text-muted);
  line-height: 1.6;
}

.import-types-panel {
  margin-top: 0.85rem;
}

.import-types-panel h4 {
  margin: 0 0 0.5rem;
  font-size: 14px;
  font-weight: 600;
}

.import-types-scroll {
  max-height: 200px;
  overflow: auto;
  border: var(--border);
  border-radius: var(--radius);
}

.import-hint-warn {
  color: #b45309;
}

.import-actions {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  align-items: center;
}

.import-file-picker {
  display: inline-flex;
  align-items: center;
  height: var(--control-h);
  padding: 0 12px;
  border: var(--border);
  border-radius: var(--radius);
  background: #fff;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-muted);
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-file-picker input {
  display: none;
}

.import-message {
  margin: 0.75rem 0 0;
  font-size: 14px;
}

.import-message.ok {
  color: #047857;
}

.import-message.err {
  color: #b91c1c;
}

.import-report {
  margin-top: 1rem;
}

.import-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  font-size: 14px;
  margin-bottom: 0.75rem;
}

.import-summary .label {
  color: var(--text-muted);
  margin-right: 0.35rem;
}

.import-summary .value {
  font-weight: 600;
}

.import-subsection {
  margin-top: 0.75rem;
}

.import-subsection .table-wrap {
  border: var(--border);
  border-radius: var(--radius);
}
</style>
